import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconGreenCheck, LazyIconIntegrationMijnwebwinkel, LazyIconIntegrationOdoo, LazyIconIntegrationPicqer, LazyIconIntegrationReturnless, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["IconGreenCheck", LazyIconGreenCheck],
["IconIntegrationMijnwebwinkel", LazyIconIntegrationMijnwebwinkel],
["IconIntegrationOdoo", LazyIconIntegrationOdoo],
["IconIntegrationPicqer", LazyIconIntegrationPicqer],
["IconIntegrationReturnless", LazyIconIntegrationReturnless],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
